import { leadForwardingProjectSchema } from "./leadForwardingProjectSchema";
import { z } from "zod";

export const leadForwardingProjectsResponseSchema = z.array(
  z.lazy(() => leadForwardingProjectSchema),
);

export type LeadForwardingProjectsResponse = z.infer<typeof leadForwardingProjectsResponseSchema>;
